import React from 'react';
import SearchIcon from '@rsuite/icons/Search';
import './App.css';

import BedroomBabySharpIcon from '@mui/icons-material/BedroomBabySharp';

// Tailwind
import { Button,Input,Radio  } from "@material-tailwind/react";

import { BookmarkIcon,} from "@heroicons/react/24/outline";

function App() {

  return (
    <>
       <div className='myBox  mx-[5%] my-[50px]  rounded-lg px-[7%] py-[50px] border-2 border-[#dba237]'> 
          <div className='lg:flex justify-between'>
             <div className='flex'>
                <BedroomBabySharpIcon fontSize="large" className='bg-[#900c3e] mr-3 text-[white]' />
                <span className='text-[#000000] text-2xl font-bold'>Company</span>
            </div>

            <div className='flex lg:mt-0 mt-4'>
                <Input label="Search here"   color='brown' icon={<SearchIcon/>} />
                <Button color="red" className='ml-1 w-[200px] bg-[#900c3e] text-[white]'>Request</Button>
            </div>
             
          </div>

          <h2 className='text-center mt-[50px] mb-4 lg:text-2xl text-xl text-[brown]'>Register for a free demo</h2>

            <div className='grid lg:grid-cols-2 grid-cols-1 gap-5  mt-[50px]'>
           
            {/* Start */}
            <div className='my-2'>
               <Input  variant="static" label="Full Name" color="brown" placeholder="Enter Full Name" />   
            </div>
               
            {/* End */}

            {/* Start */}
            <div className='my-2'>
                <Input variant="static" label="Email ID" color="brown" placeholder="Enter Email ID" /> 
            </div>
             {/* End */} 

              {/* Start */}
            
    
              <div className='my-2'>
                <Input variant="static" label="Job Title" color="brown" placeholder="Enter Job Title" /> 
               </div>
          
             {/* End */}  

              {/* Start */}
            <div className='my-2'>
                <Input variant="static" label="Mobile No." color="brown" placeholder="Enter Mobile No." /> 
            </div>
             {/* End */} 

    
          </div>


             <label className="mt-4 block text-sm text-[brown]">Company Size</label>
             <div className="grid lg:grid-cols-4 grid-cols-2  gap-1 p-0">
                <Radio  name="color" color="brown"  defaultChecked label="Less than 50" />
                <Radio  name="color" color="brown"  label="50 to 100" />
                <Radio  name="color" color="brown"  label="101 to 300" />
                <Radio  name="color" color="brown"  label="More than 300" />
            </div>


       <div className="flex justify-center mt-4">
          <Button className="flex items-center gap-3 bg-[brown]" >
              <BookmarkIcon strokeWidth={2} className="h-5 w-5" /> Request a Demo
         </Button>
      </div>
          


       </div>    
      </>
  );
}

export default App;
